import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonResponse } from '../models';
import { environment } from '../../../environments/environment';
import { first, Observable } from 'rxjs';
import { SchoolUniversity } from '../models/school/school-university';
import { School } from '../models/school/school';
import { ProfileUserUniversitySchoolUniversity } from '../models/profile/profile';
import { filter } from 'rxjs/operators';
import { CurrentSchoolUniversityService } from './current-school-university.service';

@Injectable({
	providedIn: 'root',
})
export class SchoolUniversityService {
	constructor(
		private _http: HttpClient,
		private _currentSchoolUniversityService: CurrentSchoolUniversityService
	) {
		if (this._currentSchoolUniversityService.getSchoolFromStorage()) {
			this._currentSchoolUniversityService.currentSchoolId
				.pipe(
					filter(currentSchoolUniversityId => !!currentSchoolUniversityId),
					first()
				)
				.subscribe(currentSchoolUniversityId => {
					if (currentSchoolUniversityId !== null) {
						this.showSchoolUniversity(currentSchoolUniversityId).subscribe(res => {
							this._currentSchoolUniversityService.currentSchoolSubject.next(res.data);
						});
					}
				});
		}
	}

	/***** MULTITENANT *****/
	getSchoolUniversity(id: number): Observable<CommonResponse<Array<SchoolUniversity>>> {
		return this._http.get<CommonResponse<Array<SchoolUniversity>>>(`/schools_universities/${id}`);
	}

	showSchoolUniversity(id: string): Observable<CommonResponse<SchoolUniversity>> {
		return this._http.get<CommonResponse<SchoolUniversity>>(`${environment.apiUrl}/schools_universities/${id}`);
	}

	/***** UNIVERSITY *****/
	getSchoolUniversityAll(onlyActive = false): Observable<CommonResponse<Array<SchoolUniversity>>> {
		const params: Record<string, string> = {};
		if (onlyActive) {
			params['only_active'] = '1';
		}
		return this._http.get<CommonResponse<Array<SchoolUniversity>>>(`${environment.apiUniversityUrl}/schools_universities`, { params });
	}

	getUniversityIndicators(): Observable<CommonResponse<Array<any>>> {
		return this._http.get<CommonResponse<Array<any>>>(`${environment.apiUniversityUrl}/indicators`);
	}

	getSchoolUniversityMissing(): Observable<CommonResponse<Array<School>>> {
		return this._http.get<CommonResponse<Array<School>>>(`${environment.apiUniversityUrl}/schools/missing`);
	}

	createSchoolUniversity(schoolUniversity: SchoolUniversity): Observable<CommonResponse<SchoolUniversity>> {
		return this._http.post<CommonResponse<SchoolUniversity>>(`${environment.apiUniversityUrl}/schools_universities`, schoolUniversity);
	}

	showSchool(id: string): Observable<CommonResponse<SchoolUniversity>> {
		return this._http.get<CommonResponse<SchoolUniversity>>(`${environment.apiUniversityUrl}/schools_universities/${id}`);
	}

	updateSchoolUniversity(id: string, schoolUniversity: SchoolUniversity): Observable<CommonResponse<SchoolUniversity>> {
		return this._http.put<CommonResponse<SchoolUniversity>>(`${environment.apiUniversityUrl}/schools_universities/${id}`, schoolUniversity);
	}

	getProfileUsers(id: string): Observable<CommonResponse<Array<ProfileUserUniversitySchoolUniversity>>> {
		return this._http.get<CommonResponse<Array<ProfileUserUniversitySchoolUniversity>>>(`/schools_universities/${id}/profile_users`);
	}
}
